import type { GeoSetTargetable } from '@feathr/blackbox';
import type { IGeoFilterSetData } from '@feathr/extender/components';

/**
 * Converts a GeoSetTargetable model to form data for the GeoFilterModal.
 *
 * @param targetable - The geo set targetable model to convert
 * @param defaultGeoSetId - The ID of the default geofilter set from account settings
 * @returns Form data object with name, is_default, and geo filter arrays
 *
 * @example
 * const formData = convertTargetableToFormData(targetable, defaultGeoSetId);
 */
export function convertTargetableToFormData(
  targetable: GeoSetTargetable,
  defaultGeoSetId?: string,
): IGeoFilterSetData {
  return {
    name: targetable.get('name') || '',
    is_default: targetable.isDefault(defaultGeoSetId),
    included_geo_filters: targetable.get('included_geo_filters') || [],
    excluded_geo_filters: targetable.get('excluded_geo_filters') || [],
  };
}
